export const VOCAB = {
  en: {
    pages: {
      DASHBOARD: "Dashboard",
      STUDENT_DASHBOARD: "Student Dashboard",
      TEACHER_DASHBOARD: "Teacher Dashboard",
      PARENT_DASHBOARD: "Parents Dashboard",
      ONBOARDING_DASHBOARD: "Onboarding Dashboard",
      BILLING_DASHBOARD: "Finance & Accounting",
      INVENTORY_DASHBOARD: "Inventory Dashboard",
      TRANSPORT_DASHBOARD: "Transport Dashboard",
      PRINCIPAL_DASHBOARD: "Principal Dashboard",
      EVENTS: "Events & Holidays",
      ATTENDANCE: "Attendance",
      RESULTS: "Results",
      EXAMS: "Examinations",
      LEAVES: "Leave Requests",
      FEES: "Fees",
      FEE_COLLECTION: "Fee Collection",
      ADD_FEES: "Add Fees",
      CLASSES: "Classes",
      PROFILE: "Profile",
      MESSENGER: "Messenger",
      NOTIFICATIONS: "Notifications",
      SETTINGS: "Settings",
      FEEDBACK: "Feedback",
      STUDENTS: "Students",
      TEACHERS: "Teachers",
      STAFF: "Staff",
      SHUFFLE: "Shuffle Students",
      SUPPORT: "Support",
      INVENTORY: "Inventory",
      ROUTES: "Routes",
      JOURNEYS: "Journeys",
      DRIVERS: "Drivers",
      TRANSACTIONS: "Transactions",
      FEES_PARENT: "Fees Payments",
    },
  },
  hin: {
    pages: {
      DASHBOARD: "डैशबोर्ड",
      STUDENT_DASHBOARD: "डैशबोर्ड",
      TEACHER_DASHBOARD: "डैशबोर्ड",
      PARENT_DASHBOARD: "डैशबोर्ड",
      ONBOARDING_DASHBOARD: "प्रवेश डैशबोर्ड",
      BILLING_DASHBOARD: "बिलिंग डैशबोर्ड",
      INVENTORY_DASHBOARD: "इन्वेंटरी डैशबोर्ड",
      TRANSPORT_DASHBOARD: "परिवहन डैशबोर्ड",
      PRINCIPAL_DASHBOARD: "प्रधानाचार्य डैशबोर्ड",
      EVENTS: "आयोजन और छुट्टियाँ",
      ATTENDANCE: "उपस्थिति",
      RESULTS: "परिणाम",
      EXAMS: "परीक्षाएँ",
      LEAVES: "अवकाश अनुरोध",
      FEES: "शुल्क",
      CLASSES: "कक्षाएँ",
      PROFILE: "प्रोफ़ाइल",
      MESSENGER: "संदेशवाहक",
      NOTIFICATIONS: "सूचनाएँ",
      SETTINGS: "सेटिंग्स",
      FEEDBACK: "प्रतिक्रिया",
      STUDENTS: "छात्र",
      TEACHERS: "शिक्षक",
      STAFF: "कर्मचारी",
      SHUFFLE: "छात्रों को फेरबदल करें",
      SUPPORT: "सहायता",
      INVENTORY: "इन्वेंटरी",
      ROUTES: "रूट्स",
      JOURNEYS: "जर्नियो",
      DRIVERS: "ड्राइवर्स",
      TRANSACTIONS: "ट्रांसैक्शन्स",
      FEES_PARENT: "पारेंट शुल्क",
    },
  },
};
